/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchPreviewRuleMatchDetailDto
 */
export interface MdmMatchPreviewRuleMatchDetailDto {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    matchType?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    similarity?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    weight?: number;
    /**
     * 
     * @type {any}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    value1?: any | null;
    /**
     * 
     * @type {any}
     * @memberof MdmMatchPreviewRuleMatchDetailDto
     */
    value2?: any | null;
}

/**
 * Check if a given object implements the MdmMatchPreviewRuleMatchDetailDto interface.
 */
export function instanceOfMdmMatchPreviewRuleMatchDetailDto(value: object): value is MdmMatchPreviewRuleMatchDetailDto {
    return true;
}

export function MdmMatchPreviewRuleMatchDetailDtoFromJSON(json: any): MdmMatchPreviewRuleMatchDetailDto {
    return MdmMatchPreviewRuleMatchDetailDtoFromJSONTyped(json, false);
}

export function MdmMatchPreviewRuleMatchDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewRuleMatchDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'similarity': json['similarity'] == null ? undefined : json['similarity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'value1': json['value1'] == null ? undefined : json['value1'],
        'value2': json['value2'] == null ? undefined : json['value2'],
    };
}

export function MdmMatchPreviewRuleMatchDetailDtoToJSON(json: any): MdmMatchPreviewRuleMatchDetailDto {
    return MdmMatchPreviewRuleMatchDetailDtoToJSONTyped(json, false);
}

export function MdmMatchPreviewRuleMatchDetailDtoToJSONTyped(value?: MdmMatchPreviewRuleMatchDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'matchType': value['matchType'],
        'similarity': value['similarity'],
        'weight': value['weight'],
        'value1': value['value1'],
        'value2': value['value2'],
    };
}

